import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-action-confirmation-dialog',
  templateUrl: './action-confirmation-dialog.component.html',
  styleUrl: './action-confirmation-dialog.component.scss'
})
export class ActionConfirmationDialogComponent {
  @Input() title!: string;
  @Input() message!: string;
  @Input() confirmButtonText!: string;
  @Input() cancelButtonText!: string;
  @Output() confirm = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();

  constructor(private translate: TranslateService) {
  }

  ngOnInit(): void {
    if (!this.confirmButtonText) {
      this.confirmButtonText = this.translate.instant('common.actionConfirmationConfirmButton');
    }
    if (!this.cancelButtonText) {
      this.cancelButtonText = this.translate.instant('common.actionConfirmationCancelButton');
    }
  }

  onConfirm() {
    this.confirm.emit();
  }

  onCancel() {
    this.cancel.emit();
  }
}
